import { ppgConditionHueLabel } from "../../../constants/enum-to-text";
import { EnumFilter } from "../../../models/data-model/enum-filter";
import { DoubleGroupedPlotModel } from "../../../models/plotting";

export class VitalsPlotModel extends DoubleGroupedPlotModel {
  constructor(dataModel: any, plotTypeOptions: string[], chartId: string) {
    super(dataModel, plotTypeOptions, chartId);
    this.valueKey = "measurement_value";
    this.filterKey = "measurement_type";
    this.dateTimeKey = "measurement_datetime";
    this.extraFilters = [new EnumFilter("tags", ["Not tagged", "--", "QPPG"])];
    this.hueKey = {
      "heart rate": "ppgConditions",
      SpO2: "ppgConditions",
      "blood pressure systolic": "data_source",
      "blood pressure diastolic": "data_source",
    };
    this.styleKey = {
      "heart rate": "data_source",
      SpO2: "data_source",
      "blood pressure systolic": "data_source",
      "blood pressure diastolic": "data_source",
    };

    this.colorMapping = {
      "Condition 1": "rgba(187, 22, 163, 1)",
      "Condition 2": "rgba(5, 195, 222, 1)",
      "--": "rgba(37, 40, 42, 1)",
      "Patient / Physician": "rgba(37, 40, 42, 1)",
    };
    this.styleMapping = {
      "PPG-derived": "circle",
      "SQ-algo": "triangle",
      "Patient / Physician": "rect",
    };
  }

  override hueLabel(hue: string) {
    return ppgConditionHueLabel(hue);
  }
}
